// ---------------------------------------------- modules import
import { ThunkAction } from "redux-thunk";

import Actions from "./actions";
import { IAlbum, AlbumAction } from "./common";
import { AppState } from "../rootReducer";
import { IThunkExtraArgument } from "../../index";

// ---------------------------------------------- thunk actions
export const thunkAddAlbum = (
  album: IAlbum,
  collectionPath: string
): ThunkAction<void, AppState, IThunkExtraArgument, AlbumAction> => (
  dispatch,
  getAppState,
  { getFirebase }
) => {
  const firebase = getFirebase();
  const { id, ...data } = album;

  dispatch(Actions.addBegin());

  firebase
    .firestore()
    .collection(collectionPath)
    .add(data)
    .then(() => dispatch(Actions.addSuccess()))
    .catch(error => dispatch(Actions.addError(error.message)));
};

export const thunkUpdateAlbum = (
  album: IAlbum,
  collectionPath: string
): ThunkAction<void, AppState, IThunkExtraArgument, AlbumAction> => (
  dispatch,
  getAppState,
  { getFirebase }
) => {
  const firebase = getFirebase();
  const { id, ...data } = album;

  dispatch(Actions.updateBegin());

  firebase
    .firestore()
    .collection(collectionPath)
    .doc(id)
    .update(data)
    .then(() => dispatch(Actions.updateSuccess()))
    .catch(error => dispatch(Actions.updateError(error.message)));
};

export const thunkDeleteAlbum = (
  id: string,
  collectionPath: string
): ThunkAction<void, AppState, IThunkExtraArgument, AlbumAction> => (
  dispatch,
  getAppState,
  { getFirebase }
) => {
  const firebase = getFirebase();

  dispatch(Actions.deleteBegin());

  firebase
    .firestore()
    .collection(collectionPath)
    .doc(id)
    .delete()
    .then(() => dispatch(Actions.deleteSuccess()))
    .catch(error => dispatch(Actions.deleteError(error.message)));
};
